module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-craft-64-active.ff638dc3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-craft-64-active.png
// module id = 3194
// module chunks = 11